import { createContext, useContext, useState } from 'react';

const CardContext = createContext({});

export function CardProvider({ children }) {
  const initialCardInfo = {
    firstName: '',
    lastName: '',
    phone: '',
    billingAddress: {
      country: 'US',
      state: '',
      city: '',
      postalCode: '',
      streetAddress1: '',
      streetAddress2: ''
    },
    debitCard: {
      number: '',
      year: '',
      month: '',
      cvv: '',
      type: ''
    }
  };
  const [cardInfo, setCardInfo] = useState(initialCardInfo);

  return (
    <CardContext.Provider
      value={{
        cardInfo,
        setCardInfo
      }}
    >
      {children}
    </CardContext.Provider>
  );
}

function useCard() {
  return useContext(CardContext);
}

export default useCard;
